import { AddSingleProductToShoppingCartResponseOut, SingleActionResponse } from '../../store/api';
import { globalErrorResponse, showNotification } from '../../store/notifications/actions';
import { invalidateCartSummaryQuery } from './useCartSummaryQuery';
import { failUpdateToCart } from '../../store/products/actionsCart';
import { AppDispatch } from '../../store';
import { ListContentSource } from '../../store/constants';
import { TFunction } from 'i18next';

type Params = {
    t: TFunction;
    dispatch: AppDispatch;
    setLoading: (loading: boolean) => void;
    performChecks: boolean;
    source: ListContentSource;
    notificationMessage: string;
    apiCallback: () => Promise<AddSingleProductToShoppingCartResponseOut>;
    callback?: () => void;
};

export const singleUpdateToCart = ({
    t,
    dispatch,
    setLoading,
    performChecks,
    source,
    notificationMessage,
    apiCallback,
    callback = () => {}
}: Params): Promise<SingleActionResponse> => {
    setLoading(true);

    return apiCallback()
        .then(data => mapSingleResponseOutToSingleActionResponse(data))
        .then(data => {
            if (data.alreadyInListProducts.length < 1 && data.preOrderedProducts.length < 1) {
                dispatch(showNotification(notificationMessage));
                invalidateCartSummaryQuery().then();

                callback();
            }
            return data;
        })
        .catch(error => {
            if (!performChecks) {
                dispatch(failUpdateToCart({ t, error, source, onSuccess: callback }));
            } else {
                dispatch(globalErrorResponse(error));
            }
            return Promise.reject(error);
        })
        .finally(() => setLoading(false));
};

const mapSingleResponseOutToSingleActionResponse = (
    data: AddSingleProductToShoppingCartResponseOut
): SingleActionResponse => {
    return {
        alreadyInListProducts: data.alreadyInListProduct ? [data.alreadyInListProduct] : [],
        preOrderedProducts: data.preOrderedProduct ? [data.preOrderedProduct] : []
    };
};
